<template>
  <div style="width: 100%;">
    <span>IP教师占比</span>
    <div style="width:100%;display: flex; justify-content: center;;" class="seven">
      <div id="seven" style="width:100%; height:200px;margin-left: 40px;">
      </div>
    </div>

    <el-dialog  title="客资分析详情" append-to-body :close-on-click-modal="false" :visible.sync="isTable"   width="80%"  :before-close="handleisShowRepresentative">
        <el-table  :data="list"  :header-cell-style="{   background: '#fafafa',   'text-align':'center'  }" :cell-style="{'text-align':'center'}" border  height="700" >
              <el-table-column prop="customerId" label="订单号" >
                <template slot-scope="scope"> {{ scope.row.customerId }} </template>
              </el-table-column>
              <el-table-column prop="customerWx" label="微信号" width="110" > </el-table-column>
              <el-table-column prop="regionName" label="所在地域" width="110" ></el-table-column>
              <el-table-column prop="channelType" label="渠道" width="110" >
                <template slot-scope="scope">
                    <div v-if="scope.row.channelType === 1">线上</div>
                    <div v-if="scope.row.channelType === 2">线下</div>
                    <div v-if="scope.row.channelType === 3">转介绍</div>
                </template>
              </el-table-column>
              <el-table-column label="微信添加状态(新)" width="180" header-align="center" >
                <template slot-scope="scope">
                    <span v-if="scope.row.customerState === 1">新客</span>
                    <span v-if="scope.row.customerState === 2">通过</span>
                    <span v-if="scope.row.customerState === 3">未通过</span>
                    <span v-if="scope.row.customerState === 4">不存在</span>
                </template>
              </el-table-column>
              <el-table-column prop="customerAccountName" label="销售" width="110" >
                  <template slot-scope="scope">
                    <span v-if="scope.row.customerAccount === '10015'">杨佳琪</span>
                    <span v-else-if="scope.row.customerAccount === '10014'">王威</span>
                    <span v-else-if="scope.row.customerAccount === '15210610322'">陈铮</span>
                    <span v-else-if="scope.row.customerAccount === '17620487163'">邓乔</span>
                    <span v-else-if="scope.row.customerAccount === '18768101243'">赵薇</span>
                    <span v-else-if="scope.row.customerAccount === '15201251274'">苏芮</span>
                    <span v-else>{{ scope.row.customerAccountName }}</span>
                  </template>
              </el-table-column>
              <el-table-column label="成单状态" width="100px" header-align="center" align="center" >
                <template slot-scope="scope">
                  <span v-if="scope.row.type === 1">未成单</span>
                  <span v-if="scope.row.type === 2">已成单</span>
                  <span v-if="scope.row.type === 0">待成单</span>
                </template>
              </el-table-column>
              <el-table-column prop="intentionName" label="意向度" width="110" ></el-table-column>
              <el-table-column prop="customerTeacherName" label="老师" width="100" >
                <template slot-scope="scope">
                  <span v-if="scope.row.customerTeacherid === 1">小单老师</span>
                  <span v-if="scope.row.customerTeacherid === 2">大单老师</span>
                  <span v-if="scope.row.customerTeacherid === 3">刘老师</span>
                  <span v-if="scope.row.customerTeacherid === 4">杨老师</span>
                </template>
              </el-table-column>
              <el-table-column prop="customerStudent" label="学生姓名" width="120" ></el-table-column>
              <el-table-column prop="sourceName" label="客资来源" width="100" ></el-table-column>
              <el-table-column prop="sourcepeopleName" label="来源负责人" width="100" ></el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="180" > </el-table-column>
              
        </el-table>
        <el-pagination 
          layout="prev, pager, next,sizes, jumper" 
          @size-change="handleSizeChange" 
          @current-change="handleCurrentChange" 
          :current-page="pageNum" 
          :page-size="pageSize"
          :total="total" 
          style="text-align: end;padding-top: 30px;">
        </el-pagination>
    </el-dialog>


  </div>
</template>

<script>
import * as echarts from 'echarts';
import axios from 'axios'
import apiBaseUrl from '../../../config/api'
export default {
  props:{
    list6:Array,
    times: Array,
  },
  name: "",
  data() {
    return {
      myChart: null,
      isTable: false,
      list:[],

      id: '',

      total: 0,
      pageNum: 1,
      pageSize: 10,
    }
  },
  mounted() {
    this.initBie()
  },
  methods: {

    handleSizeChange(val) {
      this.pageSize = val
      this.handlesourceDetail()
    },

    handleCurrentChange(val) {
      this.pageNum = val
      this.handlesourceDetail()
    },

    handleisShowRepresentative(){
      this.isTable = false
      this.id = ''
      this.list = []
      this.pageNum = 1
      this.pageSize = 10
    },

    handlesourceDetail(){
        let data = {
          sourcePeopleId: this.id,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          time: this.times,
          type: 1,
        }
        axios.post(`${apiBaseUrl}/stat/teacherTypeDetail`,data,{headers:{'authorization': sessionStorage.getItem('tokenInfo')}, }).then(res => {
          if (res.data.code == 200) {
            this.list = res.data.data && res.data.data.entity
            this.total = res.data.data && res.data.data.allTotal
          } else {
            this.list = []
            this.total = 0
            this.$message({ message: res.data.message || res.data.msg , type: "error"  });
          }
        }).catch(error => {
          this.list = []
          this.total = 0
          this.$message({ message: error,  type: "error"  });
        });
    },


    initBie() {
      let chartDom = document.getElementById('seven');
      this.myChart = echarts.init(chartDom);
      let option;

      option = {
        // color: ['#E5195A',
        //   '#9a60b4',
        //   '#91cc75',
        //   '#73c0de',
        //   '#fc8452'],
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: '5%',
          left: 'left'
        },
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 20,
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            data: this.list6
          }
        ]
      };

      option && this.myChart.setOption(option);

      this.myChart.on('click', (params) => {
        let { id } = params.data;
        if(id){
          this.id = id
          this.isTable = true
          this.handlesourceDetail();
        }
      });

      // myChart.on('click', (params) => {
      //   let values = params.data
      //   this.$emit('handleEventIncome6',true,values)
      // })

      // window.onresize = function () {
      //   myChart.resize();
      // }

    }
  },
  watch: {
    list6: {
      deep: true,
      handler (val) {
        this.initBie()
      },
    },
  },
  components: {

  },
}
</script>

<style scoped></style>




// WEBPACK FOOTER //
// src/statistics/components/income6.vue